/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { PubNubMessage } from "./PubNubMessage";
export const PubNubMessageHistoryResponse = core.serialization.object({
    channels: core.serialization.record(core.serialization.string(), core.serialization.list(PubNubMessage)),
});
